import { Box, Token } from '@usealloy/component-library';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const EvaluationDetailWrapper = styled.div`
  width: 100%;
  padding: 0 var(--cl-space-4);

  .evaluation-detail {
    padding: 0;
  }
`;

export const FontSizeBox = styled(Box)`
  &&&& {
    font-size: var(--cl-font-size-2);
  }
`;

export const StyledLink = styled(Link)`
  font-weight: var(--cl-font-weight-normal);
  text-transform: none;
  margin: 0;
`;

export const StyledJourneyLink = styled(StyledLink)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledToken = styled(Token)`
  align-self: flex-end;
  max-width: fit-content;
  min-width: 100px;
`;

export const StyledDownloadLink = styled.a`
  font-size: var(--cl-font-size-2);
  line-height: var(--cl-line-height-2);
`;

export const StyledDownloadButton = styled.button`
  font-size: var(--cl-font-size-2);
  line-height: var(--cl-line-height-2);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--cl-juicyBlue-600);
  font-weight: 400;

  &:hover,
  &:active,
  &:focus {
    outline: 0;
    text-decoration: underline;
  }
`;
